// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__1b3tM","spin":"Loader_spin__2T7ab","aaloader":"Loader_aaloader__1Tgop"};